angular.module('angus.filters')
	.filter('utcDate', ['moment', function(moment) {
		return function(input, formatString) {
			return input ? moment.utc(input).format(formatString || 'll') : '';
		};
	}]);